"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuableItemWithStartDate = void 0;
class ValuableItemWithStartDate {
}
exports.ValuableItemWithStartDate = ValuableItemWithStartDate;
//# sourceMappingURL=ValuableItemWithStartDate.js.map